import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBAdditionalPopupSuccesed } from 'pages/Internet/store/selectors/servicesSelectors';
import { closeServiceAdditionalPopup } from 'pages/Internet/store/actions/servicesActions';
import { PopupButton, PopupButtonLink, PopupText } from '../../../../components';

export const SuccesedText = compose(connect(
  (state) => ({
    children: getFTTBAdditionalPopupSuccesed(state).text,
    shouldRender: !!getFTTBAdditionalPopupSuccesed(state).text,
  }),
), withRenderFlag)(PopupText);

export const SuccesedTitle = compose(
  connect(
    (state) => ({
      children: getFTTBAdditionalPopupSuccesed(state).title,
      shouldRender: !!getFTTBAdditionalPopupSuccesed(state).title,
      isTitle: true,
    }),
  ), withRenderFlag,
)(PopupText);

export const SuccesedGoToMessagesLink = compose(
  connect(
    (state) => ({
      url: getFTTBAdditionalPopupSuccesed(state).toMessagesBtn?.link,
      children: getFTTBAdditionalPopupSuccesed(state).toMessagesBtn?.text,
      shouldRender: !!getFTTBAdditionalPopupSuccesed(state).toMessagesBtn?.text,
    }),
  ), withRenderFlag,
)(PopupButton);

export const SuccesedGoBackButtonLink = compose(
  connect(
    (state) => ({
      url: getFTTBAdditionalPopupSuccesed(state).comeBackBtn?.link,
      children: getFTTBAdditionalPopupSuccesed(state).comeBackBtn?.text,
      shouldRender: !!getFTTBAdditionalPopupSuccesed(state).comeBackBtn?.text,
    }),
    {
      onClick: closeServiceAdditionalPopup,
    },
  ), withRenderFlag,
)(PopupButtonLink);
